import { hasAutomaticEntityValidator } from "@frui.ts/validation";
import { Observer } from "mobx-react-lite";
import React from "react";
import { bound } from "@frui.ts/helpers/dist";
import type { IBindingProps } from "@frui.ts/views";
import { BindingComponent } from "@frui.ts/views";
import type { FormLabelProps } from "react-bootstrap";
import { Form } from "react-bootstrap";
import hasRequiredProperty from "utils/hasRequiredProperty";

export interface LabelProps {
  required: boolean | "autoDetect";
  requiredMarker?: React.ReactNode;
}

export class FormLabel<TTarget> extends BindingComponent<TTarget, IBindingProps<TTarget> & LabelProps & FormLabelProps> {
  static defaultProps = {
    required: "autoDetect",
    requiredMarker: <span className="text-danger pl-1">*</span>,
  };

  @bound
  protected renderInner() {
    const { children, requiredMarker, required, ...props } = this.props;
    const { target, property, ...rest } = props as { target: TTarget; property: keyof TTarget & string };
    let requiredNode;

    if (
      required === true ||
      (required === "autoDetect" && hasAutomaticEntityValidator(target) && hasRequiredProperty<TTarget>(target, property))
    ) {
      requiredNode = requiredMarker;
    }

    return (
      <Form.Label {...rest}>
        {children}
        {requiredNode}
      </Form.Label>
    );
  }

  render() {
    return <Observer render={this.renderInner} />;
  }
}

export default FormLabel;
